module.exports = __webpack_public_path__ + "img/Australia.b89fe60d.png";